import Module from './Module';
import LoaderLoader from '../../loader/LoaderLoader';

/**
 * This Module is dedicated to loading content.
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class LoaderModule extends Module{
	constructor(bootstrap){
		super(bootstrap);
		this.loader 	= new LoaderLoader();
	}

	get priority(){
		return -1;
	}

	async before(){
		this.loader.reset();
	}
}

export { LoaderModule };